<template>
  <div class="menu-list page-box">

    <div class="page-content">
      <div class="content-header">
        <vs-button
          v-if="isAuth('sys:menu:save')"
          color="primary"
          type="filled"
          @click="addHandle"
        >新增</vs-button>
      </div>
<!--      default-expand-all-->
      <el-table
        :data="listData"
        style="width: 100%;margin-bottom: 20px;"
        :header-cell-style="{background:'#EFF3FF',color:'#5E5873'}"
        row-key="menuId"
        :tree-props="{
           children: 'children',
        }"
      >
        <!--        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"-->
        <el-table-column
          prop="name"
          label="名称"
        >
        </el-table-column>
        <el-table-column
          prop="parentName"
          label="上级菜单"
        >
          <template slot-scope="scope">
            {{scope.row.parentName || '-'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="icon"
          label="图标"
        >
          <template slot-scope="scope">
            <icon-svg
              :icon-class="scope.row.icon"
              class="icon-el-menu"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="类型"
        >
          <template slot-scope="scope">
            <div
              class="self-tag"
              :style="getType(scope.row)"
            >{{getTypeText(scope.row)}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="排序号">
        </el-table-column>
        <el-table-column
          prop="url"
          label="菜单URL"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.url || '-'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="perms"
          :show-overflow-tooltip="true"
          label="授权标识">
          <template slot-scope="scope">
            <span>{{scope.row.perms ||'-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="isAuth('sys:menu:update')"
              @click="editHandle(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="text"
              v-if="isAuth('sys:menu:delete')"
              @click.native="deleteHandle(scope.row.menuId)"
              class="delete-btn"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-dialog
      :dialog-show="addDialogShow"
      @close="closeDialog"
      @add-success="addSuccess"
    ></add-dialog>
    <edit-dialog
      :menu-id="currentMenuId"
      :dialog-show="editDialogShow"
      @close="closeEidtDialog"
      @edit-success="editSuccess"
    ></edit-dialog>
  </div>
</template>

<script>
import editDialog from "@/components/sys/menu/editDialog";
import addDialog from "@/components/sys/menu/addDialog";
import { mapGetters } from 'vuex'
import queryHeader from "@/components/sys/menu/queryHeader";
import { queryMenu,deleteMenu } from "@/api/sys/menu";
import { treeDataTranslate } from '@/utils/common'
import { colorRgba } from '@/utils/index'
export default {
  name: "index",
  components: {
    queryHeader,
    addDialog,
    editDialog,
  },
  data() {
    return {
      red: '#D85E5F',
      green: '#41B883',
      listData: [],
      addDialogShow: false,
      editDialogShow: false,
      currentMenuId: 0,
    }
  },
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.getMenu();
  },
  methods: {
    addHandle(){
      this.addDialogShow = true;
    },
    addSuccess(){
      this.addDialogShow = false;
      this.getMenu();
    },
    getMenu(){
      queryMenu().then((data) => {
        this.listData = treeDataTranslate(data,'menuId');
      })
    },
    closeDialog(){
      this.addDialogShow = false;
    },
    editSuccess(){
      this.currentMenuId = 0;
      this.editDialogShow = false;
      this.getMenu();
    },
    closeEidtDialog(){
      this.currentMenuId = 0;
      this.editDialogShow = false;
    },
    getType(row){
      switch (row.type){
        case 0:
          // return 'primary';
          return {
            backgroundColor: colorRgba(this.themeColor,0.1),
            color: this.themeColor,
          };
        case 1:
          return {
            backgroundColor: colorRgba(this.green,0.1),
            color: this.green,
          };
        case 2:
          return {
            backgroundColor: colorRgba('#f4f3f3',0.5),
            color: '#6B6C7B',
          };
      }
    },
    getTypeText(row){
      switch (row.type){
        case 0:
          return '目录';
        case 1:
          return '菜单';
        case 2:
          return '按钮';
      }
    },
    editHandle(row){

      setTimeout(() => {
        this.editDialogShow = true;
        this.currentMenuId = row.menuId;
      },200);
    },
    deleteHandle(id){
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMenu(id).then((res) => {
          if(res.code == 200){
            this.getMenu();
          }else {
            this.$message.error(res.msg);
          }
        }).catch((err) => {
          console.log(err);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-list {
  .page-content {
    padding-bottom: 200px;
  }
  .content-header{
    padding-bottom: 20px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
  .icon-el-menu {
    font-size: 20px;
  }

}
</style>
